var map = {
	"./15tiqan.svg": "RBeZ",
	"./404.svg": "sEM+",
	"./arrow-down.svg": "Peom",
	"./down.svg": "LHwD",
	"./sx.svg": "GD7D",
	"./transactionDown.svg": "IPLS",
	"./transactionUp.svg": "u7Di",
	"./up.svg": "S+/b"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 152